import { render, staticRenderFns } from "./Moneylog.vue?vue&type=template&id=08bf9240&scoped=true"
import script from "./Moneylog.vue?vue&type=script&lang=js"
export * from "./Moneylog.vue?vue&type=script&lang=js"
import style0 from "./Moneylog.vue?vue&type=style&index=0&id=08bf9240&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf9240",
  null
  
)

export default component.exports